import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgGrid = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.802 10H5.198A2.2 2.2 0 0 1 3 7.802V5.198C3 3.984 3.984 3 5.198 3h2.604C9.016 3 10 3.984 10 5.198v2.604A2.2 2.2 0 0 1 7.802 10M18.802 21h-2.604A2.2 2.2 0 0 1 14 18.802v-2.604c0-1.214.984-2.198 2.198-2.198h2.604c1.214 0 2.198.984 2.198 2.198v2.604A2.2 2.2 0 0 1 18.802 21M7.802 21H5.198A2.2 2.2 0 0 1 3 18.802v-2.604C3 14.984 3.984 14 5.198 14h2.604C9.016 14 10 14.984 10 16.198v2.604A2.2 2.2 0 0 1 7.802 21M18.802 10h-2.604A2.2 2.2 0 0 1 14 7.802V5.198C14 3.984 14.984 3 16.198 3h2.604C20.016 3 21 3.984 21 5.198v2.604A2.2 2.2 0 0 1 18.802 10"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgGrid);
export default ForwardRef;
